export const useResultViewTypeYeekee5 = () =>
  useState<string>("resultViewTypeYeekee5", () => "shortview");
export const useResultViewTypeYeekee10 = () =>
  useState<string>("rsultViewTypeYeekee10", () => "shortview");
export const useResultViewTypeYeekee15 = () =>
  useState<string>("resultViewTypeYeekee15", () => "shortview");

export const useBetOneDigitType = () =>
  useState<string>("betOneDigitType", () => []);
export const useBetTwoDigitType = () =>
  useState<string>("betTwoDigitType", () => []);
export const useBetThreeDigitType = () =>
  useState<Number>("betThreeDigitType", () => 0);

export const useBetThreeDigitTypeFrontBack = () =>
  useState<Number>("betThreeDigitTypeFrontBack", () => 0);
export const useBetTypeSelect = () =>
  useState<string>("betTypeSelect", () => []);
export const useBetType = () => useState<string>("betType", () => []);
export const useCurrentBetType = () =>
  useState<string>("currentBetType", () => "");
export const useBetCategory = () =>
  useState<string>("betCategory", () => "input");

// export const usePatternType = () => useState<string>("patternType", () => []);
export const useCurrentPatternType = () =>
  useState<string>("currentPatternType", () => "");
export const usePatternCategory = () =>
  useState<string>("patternCategory", () => "select");
export const usePatternNumbers = () =>
  useState<string>("patternNumbers", () => []);
export const usePatternThreeDigitType = () =>
  useState<Number>("patternThreeDigitType", () => 0);

export const usePatternAlternate = () =>
  useState<boolean>("patternAlternate", () => false);

export const useGameCurrentTimeLeft = () =>
  useState<number>("gameCurrentTimeLeft", () => "");
export const useShootCurrentTimeLeft = () =>
  useState<number>("shootCurrentTimeLeft", () => "");
export const useBetThreeUpper = () =>
  useState<string>("betThreeUpper", () => []);
export const useBetThreeShuffle = () =>
  useState<string>("betThreeShuffle", () => []);

export const useBetThreeFront = () =>
  useState<string>("betThreeFront", () => []);
export const useBetThreeBack = () => useState<string>("betThreeBack", () => []);

export const useBetTwoUpper = () => useState<string>("betTwoUpper", () => []);
export const useBetTwoUnder = () => useState<string>("betTwoUnder", () => []);
export const useBetOneUpper = () => useState<string>("betOneUpper", () => []);
export const useBetOneUnder = () => useState<string>("betOneUnder", () => []);
export const useBetNumbers = () => useState<string>("betNumbers", () => []);

export const useTwoDigitSelectedFront = () =>
  useState<string>("TwoDigitSelectedFront", () => []);
export const useTwoDigitSelectedBack = () =>
  useState<string>("TwoDigitSelectedBack", () => []);
export const useTwoDigitSelectedNineTeen = () =>
  useState<string>("TwoDigitSelectedNineTeen", () => []);
export const useRateLimit = () => useState<string>("RateLimit", () => []);
